import Hero from "@/components/Hero";
import WelcomeSection from "@/components/WelcomeSection";
import StatsSection from "@/components/StatsSection";
import VideoSection from "@/components/VideoSection";
import MaklumatSection from "@/components/MaklumatSection";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main>
        <Hero />
        <WelcomeSection />
        <StatsSection />
        <VideoSection />
        <MaklumatSection />
      </main>
      <Footer />
    </div>
  );
}
